//CRN_20260115 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { MdmDashboardWidgetTitles } from 'src/app/core/consts';

@Injectable({ providedIn: 'root' })

export class ChartConfigService {

  public static readonly OtherSliceRawLabel: string="__other__";

  private readonly devicesByOsComplianceMap={
    "androidcompliant"    : { label: "Android Compliant",     color: "--vz-success" },
    "androidingraceperiod": { label: "Android InGracePeriod", color: "--vz-warning" },
    "androidnoncompliant" : { label: "Android Noncompliant",  color: "--vz-danger"  },
    "androidunknown"      : { label: "Android Unknown",       color: "--vz-danger"  },
    "ioscompliant"        : { label: "iOS Compliant",         color: "--vz-success" },
    "iosingraceperiod"    : { label: "iOS InGracePeriod",     color: "--vz-warning" },
    "iosnoncompliant"     : { label: "iOS Noncompliant",      color: "--vz-danger"  },
    "iosunknown"          : { label: "iOS Unknown",           color: "--vz-danger"  },
    "othernoncompliant"   : { label: "Other Noncompliant",    color: "--vz-danger"  },
  };

  private pieLabelColorMap: any={
    [MdmDashboardWidgetTitles.devicesByEncrypted]: {
      "encrypted"   : { label: "Encrypted",     color: "--vz-success" },
      "notencrypted": { label: "Not Encrypted", color: "--vz-danger"  },
    },
    [MdmDashboardWidgetTitles.devicesByCarrier]: {
      "ee"      : { label: "EE",       color: "--vz-info"      },
      "o2"      : { label: "O2",       color: "--vz-primary"   },
      "other"   : { label: "Other",    color: "--vz-secondary" },
      "three"   : { label: "Three",    color: "--vz-purple"    },
      "vodafone": { label: "Vodafone", color: "--vz-teal"      },
      "webbing" : { label: "Webbing",  color: "--vz-pink"      },
    },
    [MdmDashboardWidgetTitles.devicesByCompanyManaged]: {
      "company"  : { label: "Company",   color: "--vz-success"   },
      "corporate": { label: "Corporate", color: "--vz-success"   },
      "personal" : { label: "Personal",  color: "--vz-secondary" },
      "unknown"  : { label: "Unknown",   color: "--vz-danger"    },
    },
    [MdmDashboardWidgetTitles.devicesByJailbroken]: {
      "jailbroken"   : { label: "Jailbroken",     color: "--vz-danger"  },
      "notjailbroken": { label: "Not Jailbroken", color: "--vz-success" },
      "unknown"      : { label: "Unknown",        color: "--vz-danger"  },
    },
    [MdmDashboardWidgetTitles.devicesByManagementState]: {
      "managed"      : { label: "Managed",       color: "--vz-success" },
      "retirepending": { label: "RetirePending", color: "--vz-warning" },
      "unknown"      : { label: "Unknown",       color: "--vz-danger"  },
      "wipepending"  : { label: "WipePending",   color: "--vz-danger"  },
    },
    [MdmDashboardWidgetTitles.devicesByManufacturer]: {
      "apple"    : { label: "Apple",     color: "--vz-info"      },
      "google"   : { label: "Google",    color: "--vz-primary"   },
      "honeywell": { label: "Honeywell", color: "--vz-secondary" },
      "huawei"   : { label: "Huawei",    color: "--vz-success"   },
      "motorola" : { label: "Motorola",  color: "--vz-pink"      },
      "samsung"  : { label: "Samsung",   color: "--vz-purple"    },
      "sony"     : { label: "Sony",      color: "--vz-teal"      },
      "other"    : { label: "Other",     color: "--vz-danger"    },
    },
    [MdmDashboardWidgetTitles.devicesByOperatingSystem]: {
      "android": { label: "Android", color: "--vz-purple" },
      "ios"    : { label: "iOS",     color: "--vz-info"   },
      "other"  : { label: "Other",   color: "--vz-danger" },
    },
    [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_Intune]   : this.devicesByOsComplianceMap,
    [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_Ours]     : this.devicesByOsComplianceMap,
    [MdmDashboardWidgetTitles.devicesByOperatingSystemCompliant_OursMinor]: this.devicesByOsComplianceMap,
    [MdmDashboardWidgetTitles.devicesBySupervised]: {
      "notsupervised": { label: "Not Supervised", color: "--vz-danger"  },
      "supervised"   : { label: "Supervised",     color: "--vz-success" },
      "unknown"      : { label: "Unknown",        color: "--vz-danger"  },
    },
  };

  public readonly defaultColoursArray: string[]=[
    "--vz-info",
    "--vz-primary",
    "--vz-secondary",
    "--vz-success",
    "--vz-warning",
    "--vz-purple",
    "--vz-teal",
    "--vz-pink",
    "--vz-lime",
    "--vz-indigo",
    "--vz-brown",
    "--vz-danger",
    "rgb(154, 181, 126)",
    "rgb(126, 68, 82)",
    "rgb(86, 80, 119)",
    "rgb(232, 194, 103)",
    "--vz-cyan",
  ];

  constructor(
    private exceptionsService: ExceptionsService
  ) { }
  
  public applyPieChart(chartName : string,
                       build     : () => any,
                       assign    : (chart: any) => void,
                       setLoading: (loading: boolean) => void
                      ): void {
    try {
      assign(undefined!);
      setLoading(true);

      setTimeout(() => {
        const chart=build();

        if (!chart) {
          setLoading(false);
          return;
        }

        chart._chartRef       =null;
        chart._chartName      =chartName;
        chart.chart._chartName=chartName;

        chart.chart.events = {
          ...chart.chart.events,
          mounted: (ctx: any) => {
            chart._chartRef=ctx;
          }
        };

        assign(chart);
        setLoading(false);
      });
    }
    catch (e) {
      setLoading(false);
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public buildPieLabelsAndColours(chartName: string,
                                  rawLabels: string[]
                                 ): { displayLabels: string[], colours: string[] } {
    try {
      const fallbackColours    =this.resolveColours(this.defaultColoursArray);
      const safeFallbackColours=(fallbackColours && fallbackColours.length>0) ? fallbackColours : this.defaultColoursArray.map(x => this.resolveColours([x])?.[0] ?? x);

      const displayLabels: string[]=[];
      const colours      : string[]=[];

      for (let i=0; i<rawLabels.length; i++) {
        const raw         =rawLabels[i] ?? "";
        const key         =this.normalisePieKey(raw);
        const chartMap    =this.pieLabelColorMap?.[chartName] ?? null;
        const match       =chartMap?.[key] ?? null;
        const mappedLabel =(match?.label ?? raw);
        const mappedColour=(match?.color ?? null);
        const fallback    =safeFallbackColours[i % safeFallbackColours.length] ?? "--vz-secondary";

        if (!mappedColour) {
          displayLabels.push(mappedLabel);
          colours.push(fallback);
          continue;
        }

        const resolvedMapped=this.resolveColours([mappedColour])?.[0] ?? fallback;

        displayLabels.push(mappedLabel);
        colours.push(resolvedMapped);
      }

      return { displayLabels, colours };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return { displayLabels: rawLabels, colours: this.resolveColours(this.defaultColoursArray) };
    }
  }
  
  public createPieChart<T>(chartName     : string,
                           type          : string,
                           data          : T[],
                           labelSelector : (row: T) => string,
                           valueSelector : (row: T) => number,
                           maxChartHeight: number,
                           countsInLegend: boolean,
                           chartTippyShow: (target: HTMLElement, html: string) => void,
                           chartTippyHide: () => void,
                           onLegendClick : (chartRef: any, rawLabel: string) => void,
                           styleVariant? : string,
                           collapse?     : { enabled: boolean; topCount: number }
                          ): any {
    try {
      const counts   : number[]=[];
      const rawLabels: string[]=[];

      for (let row of data) {
        const v=valueSelector(row);

        if (Number.isFinite(v))
          counts.push(v);
        else
          counts.push(0);

        rawLabels.push(labelSelector(row));
      }

      const total=counts.reduce((a, b) => a + b, 0);

      if (counts.length==0 || total<=0)
        return undefined!;

      const mapped              =this.buildPieLabelsAndColours(chartName, rawLabels);
      let   labels              =mapped.displayLabels;
      let   colors              =mapped.colours;
      let   workingCounts       =counts;
      let   workingRaws         =rawLabels;
      let   otherExcludeRawLabels: string[]=[];

      if (collapse?.enabled && collapse.topCount > 0 && counts.length > collapse.topCount) {
        const indexed   =counts.map((c, i) => ({ c, i }));
        const topIndices=indexed.sort((a, b) => b.c - a.c)
                                .slice(0, collapse.topCount)
                                .map(x => x.i)
                                .sort((a, b) => a - b);
        const topSet    =new Set<number>(topIndices);

        const collapsedCounts: number[]=[];
        const collapsedLabels: string[]=[];
        const collapsedColors: string[]=[];
        const collapsedRaws  : string[]=[];

        let otherCount=0;

        for (let i=0; i<counts.length; i++) {
          if (topSet.has(i)) {
            collapsedCounts.push(counts[i]);
            collapsedLabels.push(labels[i]);
            collapsedColors.push(colors[i]);
            collapsedRaws  .push(rawLabels[i]);
          }
          else {
            otherCount+=counts[i];
          }
        }

        if (otherCount > 0) {
          collapsedCounts.push(otherCount);
          collapsedLabels.push("Other");
          collapsedColors.push("#adb5bd");
          collapsedRaws  .push(ChartConfigService.OtherSliceRawLabel);

          otherExcludeRawLabels=topIndices.map(i => rawLabels[i]);
        }

        workingCounts=collapsedCounts;
        workingRaws  =collapsedRaws;
        labels       =collapsedLabels;
        colors       =collapsedColors;
      }

      const isDonut       =((type ?? "").toLowerCase()=="donut");
      const effectiveStyle=(styleVariant ?? "")
                           || (
                                chartName==MdmDashboardWidgetTitles.devicesByEncrypted
                             || chartName==MdmDashboardWidgetTitles.devicesByJailbroken
                             || chartName==MdmDashboardWidgetTitles.devicesBySupervised
                              ? "status"
                              : "categorical"
                             );

      const isStatus   =(effectiveStyle ?? "").toLowerCase().startsWith("status");
      const donutSize  =(isStatus ? "72%" : "62%");
      const customScale=(isStatus ? 1.02  : 1.00);
      const offsetY    =(isStatus ? -6    : -10);

      const centrePrimary=(() => {
        const maxIndex=workingCounts.reduce((bestIdx, v, i) => v > (workingCounts[bestIdx] ?? -1) ? i : bestIdx, 0);
        const label   =labels[maxIndex] ?? "";
        const value   =workingCounts[maxIndex] ?? 0;
        const pct     =this.formatLegendPercent(value, total);
        return { label, value, pct };
      })();

      return {
        series: [...workingCounts],
        labels: [...labels],
        chart : {
          height            : maxChartHeight,
          parentHeightOffset: 0,
          type              : type,
          events            : {
            dataPointMouseEnter: (event: any, chartContext: any, config: any) => {

              const dataPointIndex: number=config?.dataPointIndex ?? -1;

              if (dataPointIndex<0)
                return;

              const series=chartContext?.w?.globals?.series ?? [];
              const labels=chartContext?.w?.globals?.labels ?? [];
              const value =series[dataPointIndex] ?? 0;
              const total =series.reduce((a: number, b: number) => a + b, 0) || 1;
              const pct   =(value / total) * 100;
              const label =labels[dataPointIndex] ?? "";

              const html=`
                <div class="apexcharts-tooltip-title">
                  ${label}: ${pct.toFixed(1)}%
                </div>
              `;

              const target=<HTMLElement>(event?.target ?? event?.currentTarget);

              chartTippyShow(target, html);
            },
            dataPointMouseLeave: () => {
              chartTippyHide();
            },
            dataPointSelection: (event: any, chartContext: any, config: any) => {

              const dataPointIndex: number=config?.dataPointIndex ?? -1;

              if (dataPointIndex<0)
                return;

              const rawLabel=workingRaws[dataPointIndex] ?? "";
              const chartRef=chartContext ?? null;

              onLegendClick(chartRef, rawLabel);
            }
          }
        },
        colors    : colors,
        dataLabels: {
          dropShadow: { enabled: false },
          enabled   : true, //isStatus ? false : true,
          formatter : (val: number, opts: any) => `${opts.w.globals.series[opts.seriesIndex]}`
        },
        fill: isStatus ? undefined : {
          type    : "gradient",
          gradient: {
            shadeIntensity: 0.25,
            inverseColors : false,
            opacityFrom   : 0.95,
            opacityTo     : 0.95,
            stops         : [0, 100]
          }
        },
        grid: {
          padding: {
            bottom: 0
          }
        },
        legend: {
          show: false
        },
        legendItems: (() => {
          const items=labels.map((l: string, i: number) => ({
            label   : countsInLegend
                      ? `${l} ${workingCounts[i] ?? 0} (${this.formatLegendPercent(workingCounts[i] ?? 0, total)})`
                      : l,
            color   : colors[i % colors.length],
            count   : workingCounts[i] ?? 0,
            rawLabel: workingRaws[i],
          }));

          if (items.length==2 && (workingCounts[0] ?? 0)==(workingCounts[1] ?? 0))
            items.reverse();

          return items;
        })(),
        plotOptions: {
          pie: {
            customScale: customScale,
            endAngle   : 540,
            offsetY    : offsetY,
            donut: {
              size  : donutSize,
              labels: {
                show: isDonut && isStatus,
                name: {
                  show   : true,
                  offsetY: -6
                },
                value: {
                  show     : true,
                  offsetY  : 6,
                  formatter: () => `${centrePrimary.value}`
                },
                total: {
                  show     : true,
                  label    : `${centrePrimary.label}`,
                  formatter: () => `${centrePrimary.pct}`
                }
              }
            }
          },
          startAngle: 180,
        },
        stroke: {
          show : true,
          width: isStatus ? 2 : 1
        },
        tooltip               : { enabled: false },
        _otherExcludeRawLabels: otherExcludeRawLabels,
        _rawDataLength        : counts.length,
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined!;
    }
  }

  public formatLegendPercent(value: number, total: number): string {
    try {
      if (!total || value <= 0)
        return "0%";

      const pct=(value / total) * 100;

      if (pct < 1)
        return "<1%";

      return `${Math.round(pct)}%`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "0%";
    }
  }

  public getChartColorsArray(colors: any) {
    try {
      colors=JSON.parse(colors);

      return colors.map(function (value: any) {
        let newValue=value.replace(" ", "");

        if (newValue.indexOf(",")===-1) {
          let color=getComputedStyle(document.documentElement).getPropertyValue(newValue);

          if (color) {
            color=color.trim();
          
            if (/^\d+\s*,\s*\d+\s*,\s*\d+$/.test(color))
              return `rgb(${color.replace(/\s+/g, "")})`;
          
            return color.replace(/\s+/g, "");

          } else {
            return newValue;
          }
        } else {
          let val=value.split(',');

          if (val.length==2) {
            var rgbaColor=getComputedStyle(document.documentElement).getPropertyValue(val[0]);
                rgbaColor="rgba(" + rgbaColor + "," + val[1] + ")";

            return rgbaColor;
          } else {
            return newValue;
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public normalisePieKey(labelText: string | undefined | null): string {
    try {
      return (labelText ?? "")
             .trim()
             .toLowerCase()
             .replace(/[^a-z0-9]/g, "");
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public resolveColours(cssVarsOrValues: string[]): string[] {
    try {
      if (typeof cssVarsOrValues==="string")
        return this.getChartColorsArray(cssVarsOrValues) ?? [];

      return this.getChartColorsArray(JSON.stringify(cssVarsOrValues)) ?? [];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public setChartMap(chartName: string, map: any): void {
    try {
      this.pieLabelColorMap[chartName]=map;
    } catch (e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Legend

  public onLegendEnter(chart: any, index: number): void {
    try {
      const chartRef=chart?._chartRef;
      const element =chartRef?.el as HTMLElement | undefined;

      if (!element)
        return;

      element.classList.add("ss-legend-hover");

      const seriesElements=element.querySelectorAll(".apexcharts-series");

      seriesElements.forEach(x => x.classList.remove("ss-slice-active"));

      const target=seriesElements[index] as HTMLElement | undefined;

      if (target)
        target.classList.add("ss-slice-active");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLegendLeave(chart: any): void {
    try {
      const chartRef=chart?._chartRef;
      const element =chartRef?.el as HTMLElement | undefined;

      if (!element)
        return;

      element.classList.remove("ss-legend-hover");

      const seriesElements=element.querySelectorAll(".apexcharts-series");

      seriesElements.forEach(x => x.classList.remove("ss-slice-active"));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
